export default __webpack_public_path__ + "static/media/POUBELLES.f38148a6.svg";